import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import FiltersBooleanBody from './filtersBooleanBody'
import filterParamsConfig from '../../../../common/constants/filterParamsConfig'

const FiltersBoolean = ({
  name,
  label,
  locationParams,
  history,
  isAtTop,
  isAtBottom,
  count,
  makeSearchLink
}) => {
  const config = filterParamsConfig[name]
  const isChecked = !!locationParams[name]

  const onChange = event => {
    const checkedValue = event.target.checked
    let newQuery = Object.assign({}, locationParams)
    delete newQuery.page

    if (checkedValue) {
      newQuery[name] = 1
    } else {
      delete newQuery[name]
    }

    history.push(makeSearchLink(newQuery))
  }

  const Icon = config.icon

  return (
    <FiltersBooleanBody
      name={name}
      label={label}
      onChange={onChange}
      isChecked={isChecked}
      isAtTop={isAtTop}
      isAtBottom={isAtBottom}
      count={count}
      icon={<Icon />}
    />
  )
}

FiltersBoolean.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  locationParams: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  isAtTop: PropTypes.bool,
  isAtBottom: PropTypes.bool,
  count: PropTypes.number,
  makeSearchLink: PropTypes.func.isRequired
}

export const FiltersBooleanComponent = FiltersBoolean
export default withRouter(FiltersBoolean)
